import WxImageViewer from './components/WxImageViewer';

export default WxImageViewer;